<template>
  <Toast group="elaborazione" position="bottom-right" />
  <prime-dialog v-model:visible="dialog.visible" :style="{ width: '450px' }" :modal="true">
    <template #header>
      <h3>Importa RID</h3>
    </template>
    <input type="file" ref="file" @change="onChangeFile($event)" accept=".xml, application/xml" />
    <prime-button v-if="data.file" label="Invia" @click="onSendFile($event)" />
  </prime-dialog>
  <Dialog v-model:visible="dialog.visibleStorni" modal header="Importa Storni RID" :style="{ width: '50%' }"
    @hide="resetStorni">
    <Loader v-if="loading" />
    <div class="flex justify-content-around" v-if="!Object.keys(storni.items).length">
      <div v-for="(btn, bank) in btns_upload_banca" :key="bank" class="flex">
        <FileUpload :key="btn.key" mode="basic" :auto="true" :accept="btn.allowed_extension" :name="btn.name"
          customUpload @uploader="uploadFileStorniRid($event, btn)" :chooseLabel="btn.bank" :class="btn.class"
          style="background-color:var(--blue-900); height: 50px; color:white; border-radius: 30px; padding: 20px 20px;" />
      </div>
    </div>
    <div v-else>
      <div class="flex justify-content-between align-items-center w-full mb-3">
        <div>
          <h4 class="m-0">Totale storni: {{ storni.items.totali }}</h4>
        </div>
        <div v-if="storni.items.new.length">
          <Button
            :label="`Conferma importazione ${storni.items.new.length} storn${storni.items.new.length > 1 ? 'i' : 'o'}`"
            class="p-button-raiser p-button-rounded p-button-success" @click="uploadStorniRid" />
        </div>
      </div>
      <Accordion :activeIndex="0">
        <AccordionTab v-for="tab in storni.accordions" :key="tab.prop">
          <template #header>
            {{ tab.header }} - {{ storni.items[`t_` + tab.prop] }}
          </template>
          <div v-if="storni.items[tab.prop].length">
            <DataTable :value="storni.items[tab.prop]" class="w-full">
              <Column field="numero" header="Numero Fattura"></Column>
              <Column field="importo" header="Importo"></Column>
              <Column header="Data">
                <template #body="{ data }">
                  {{ moment(data.data[0]).format('DD/MM/Y') }}
                </template>
              </Column>
            </DataTable>
          </div>
        </AccordionTab>
      </Accordion>
    </div>
  </Dialog>
  <Dialog v-model:visible="dialog.visibleRisultatiStorni" modal header="Risultati Importazione Storni RID"
    :style="{ width: '80%' }" @hide="resetRisultati">
    <div v-if="result_storni.length">
      <DataTable :value="result_storni" class="w-full">
        <Column field="data.numero" header="Numero Fattura"></Column>
        <Column field="data.importo" header="Importo"></Column>
        <Column field="success" header="Risultato">
          <template #body="{ data }">
            <p v-if="data.success" style="color:rgb(0,204,0)"><strong>Importazione eseguita</strong></p>
            <p v-else style="color:rgb(255,0,0)"><strong>Errore</strong></p>
          </template>
        </Column>
      </DataTable>
    </div>
  </Dialog>
  <div class="page">
    <div class="flex card">
      <prime-button label="Importa RID" icon="pi pi-file-import" class="p-button-secondary mr-3" iconPos="left"
        @click="dialog.visible = true" />
      <prime-button label="Importa STORNI RID" icon="pi pi-file-import" class="p-button-secondary mr-3" iconPos="left"
        @click="dialog.visibleStorni = true" />
    </div>
    <!-- <accordion>
      <accordion-tab>
        <template #header>
          <i class="pi pi-plus-circle"> </i>
          <span class="pl-1">Operazioni</span>
        </template>      
      </accordion-tab>
    </accordion> -->

    <data-table :value="data.items" v-model:expandedRows="expandedRows" dataKey="id" responsiveLayout="scroll">
      <template #empty>
        <div class="box-center">Nessun dato trovato.</div>
      </template>
      <column :expander="true" headerStyle="width: 3rem" />
      <column field="banca" header="Banca"></column>
      <column field="flusso" header="Flusso"></column>
      <column field="scadenze" header="Scadenze"></column>
      <column field="totale" header="Totale"></column>
      <column field="elementi" header="Elementi"></column>
      <column :exportable="false">
        <template #body="{ data }">
          <prime-button icon="pi pi-file-o" label="XML" class="p-button-rounded p-button-success mr-2"
            @click="onGetXmlButton(data.slug.banca, data.slug.flusso)" />
        </template>
      </column>
      <template #expansion="{ data }">
        <div class="subtable">
          <accordion :multiple="true">
            <accordion-tab v-for="(values, name) in data.dettagli" :key="name">
              <template #header>
                <span>Dettagli - </span>&nbsp;
                <span>{{ moment(name).format('DD/MM/YYYY') }} - </span>&nbsp;
                <span>Elementi: {{ values.length }} - </span>&nbsp;
                <span>Totale: {{ currencyFormatter.format(values.reduce((old, el) => (old + el.totale), 0))
                  }}</span>&nbsp;
              </template>
              <data-table :value="values" v-model:selection="selectedItems[data.id][name]" dataKey="numero"
                responsiveLayout="scroll">
                <column selectionMode="multiple" headerStyle="width: 3em"></column>
                <column field="numero" header="Fattura"></column>
                <column field="ragsoc" header="Cliente"></column>
                <column field="iban" header="IBAN"></column>
                <column field="rappresentante" header="Rappresentante"></column>
                <column field="data_emissione" header="Data Emissione">
                  <template #body="slotProps">
                    {{ (slotProps.data.data_emissione !== null) ?
                      moment(slotProps.data.data_emissione).format('DD/MM/YYYY') : '' }}
                  </template>
                </column>
                <column field="totale" header="Totale">
                  <template #body="slotProps">
                    {{ currencyFormatter.format((slotProps.data.totale !== null) ? slotProps.data.totale : 0) }}
                  </template>
                </column>
              </data-table>
            </accordion-tab>
          </accordion>
        </div>
      </template>
    </data-table>
  </div>
</template>

<script>
import moment from 'moment'
import Service from '@/services/ask-management/modulo-rid-fatture-clienti-service'

import PrimeButton from 'primevue/button'
import PrimeDialog from 'primevue/dialog';
import { useToast } from "primevue/usetoast";
import Loader from "@/components/Loader.vue";

export default {
  components: {
    PrimeButton,
    PrimeDialog,
    Loader,
  },

  data() {
    return {
      moment,

      currencyFormatter: new Intl.NumberFormat('it-IT', {
        style: 'currency',
        currency: 'EUR',
      }),

      expandedRows: [],
      selectedItems: {},

      dialog: {
        visible: false,
        visibleStorni: false,
        visibleRisultatiStorni: false
      },

      data: {
        items: [],
        file: null,
        type_items: ''
      },
      btns_upload_banca: {
        MPS: {
          bank: 'MPS',
          allowed_extension: '.zip',
          key: 0,
          name: 'fileMPS[]',
          class: "custom-file-upload-btn",
        },
        BPM: {
          bank: 'BPM',
          allowed_extension: '.csv',
          key: 0,
          name: 'fileBPM[]',
        },
      },
      storni: {
        items: [],
        bank: {},
        accordions: [
          { prop: 'new', header: 'OK' }, { prop: 'existent', header: 'PRESENTE' }, { prop: 'reject', header: 'SCARTATI' }
        ]
      },
      result_storni: [],
      toast: useToast(),
      loading: false,
    }
  },

  created() {
    this.service = new Service(this.$http, this.$eventBus)
    this.getAllRidInScadenza()
  },

  mounted() {

  },

  methods: {
    getAllRidInScadenza() {
      this.service.getAllRidInScadenza().then((res) => {
        this.data.items = res.items.map((el) => {
          el.id = `${el.slug.banca}_${el.slug.flusso}`
          return el
        })

        this.data.items.forEach((el) => {
          this.selectedItems[el.id] = {}
          Object.keys(el.dettagli).forEach((e) => {
            this.selectedItems[el.id][e] = []
          })
        })
      })
    },

    ////

    onGetXmlButton(banca, flusso /**, event **/) {
      let items = []
      Object.keys(this.selectedItems[`${banca}_${flusso}`]).forEach((el) => {
        items = [...items, ...this.selectedItems[`${banca}_${flusso}`][el].map((el) => el.numero)]
      })

      let filters = {}
      if (items.length > 0) {
        filters = {
          'fattura_vendita.numeri': items
        }
      }

      this.service.downloadXml(banca, flusso, filters)
    },

    onChangeFile(event) {
      event.preventDefault()
      this.data.file = null
      this.data.file = this.$refs.file.files[0]
    },

    onSendFile(/** event **/) {
      if (this.data.file) {
        this.service.uploadFileXml(this.data.file)
          .then((res) => {
            if (res) {
              this.data.items = []
              this.getAllRidInScadenza()
            }
          })
      }
    },
    uploadFileStorniRid(event, data) {
      let file = event.files[0]
      const extension = '.' + file.name.split('.')[1].toLowerCase()

      // Verifica se l'estensione è consentita
      if (extension == data.allowed_extension) {
        // Il file ha un'estensione valida
        this.toast.add({ severity: 'info', detail: 'Elaborazione in corso...', group: 'elaborazione' })
        this.loading = true
        this.service.uploadFileStorniRid(file, data.bank)
          .then((res) => {
            this.toast.removeGroup('elaborazione')
            if (res.items.success) {
              this.storni.items = res.items
              this.storni.bank = data

              this.toast.add({ severity: 'success', summary: 'Preview eseguita', detail: `Elaborazione del file di risposta eseguita correttamente`, life: 10000 });
            } else {
              this.toast.add({ severity: 'warn', summary: 'Preview fallita', detail: `Elaborazione del file di risposta non riuscita`, life: 10000 });
            }
          })
          .finally(() => {
            this.loading = false
          })
      } else {
        // Il file ha un'estensione non valida
        this.toast.add({ severity: 'warn', detail: 'Formato non supportato dalla banca selezionata' })
      }
    },
    resetStorni() {
      this.storni.items = []
      this.storni.bank = {}
      this.dialog.visibleStorni = false
    },
    uploadStorniRid() {
      if (this.storni.items.new.length) {
        this.loading = true
        this.service.confirmImportStorniRid(this.storni.items.new)
          .then((res) => {
            this.resetStorni()
            this.dialog.visibleRisultatiStorni = true
            this.result_storni = res.items
          })
          .finally(() => {
            this.loading = false
          })
      } else {
        this.toast.add({ severity: 'warn', detail: 'Non ci sono nuovi storni da confermare', life: 5000 })
      }
    },
    resetRisultati() {
      this.result_storni = []
    }
  },
}
</script>

<style scoped>
.custom-file-upload {
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  cursor: pointer;
}

.custom-file-upload-btn {
  background-color: #6c63ff !important;
  /* Colore di sfondo */
  color: white !important;
  /* Colore del testo */
  border-radius: 30px !important;
  /* Raggio degli angoli */
  padding: 10px 20px !important;
  /* Spaziatura */
  border: 2px solid transparent;
  /* Bordo trasparente */
  transition: background-color 0.3s, transform 0.3s, border 0.3s;
  /* Transizione dolce */
}

.custom-file-upload-btn:hover {
  background-color: #5a54d1;
  /* Colore di sfondo al passaggio del mouse */
  transform: translateY(-2px);
  /* Leggero sollevamento al passaggio del mouse */
}
</style>